import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import data from "../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    Summary, TotalItem,
    Selection,
    Scrolling,
    Toolbar as GridToolbar,
    Item as GridItem
} from "devextreme-react/data-grid";
import { Button, NumberBox, Popup, SelectBox, TextArea, TextBox, RadioGroup } from 'devextreme-react';
import notify from 'devextreme/ui/notify';

import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';

const dataGrid = React.createRef();

const LotElementType = [{ id: 'User', name: 'User Defined Text' }, { id: 'D/T', name: 'Date/Time Value' }, { id: 'Num', name: 'Incrementing Number' }]

function TransNumSetup(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [selectedGenerate, setGenerate] = useState('N');
    const [selectedLotElementType, setLotElementType] = useState('User');
    const [selectedFormatedText, setFormatedText] = useState('');
    const [formatsDatasource, setFormatsDatasource] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [saveFormat, setSaveFormat] = useState(false);
    const [generateFormat, setGenerateFormat] = useState('');
    const [dateFormat, setDateFormat] = useState('');
    const [showAddPopup, setSowAddPopup] = useState(false);
    const [abSetupData, setAbSetupData] = useState(null);
    const [counterNumber, setCounter] = useState(null);

    const isInitialRender = useRef(true);
    const dataGridRef = React.createRef();
    useEffect(() => {
        if (props.field.module && props.field.transactionType)
            loadSetups();
    }, [props.field.module]);
    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        if (formatsDatasource !== undefined) {
            updateFormats();
            dataGridRef.current.instance().refresh();
        }
    }, [saveFormat]);

    const handleValueChanged = (e) => {
        setGenerate(e.value);
        if (e.previousValue !== e.value && e.event) {
            setSaveFormat(prev => !prev);
        }
    };

    async function GetNextTransNo(formatsDatasource) {
        let num = formatsDatasource?.find(item => item?.name?.includes("Num: ")) ?? null;
        if (num) {
            const match = num["name"];
            const parts = match.split(": ");
            const hasLeadingZero = parts[1].startsWith('0');
            const number = parseInt(parts[1], 10);
            if (number < abSetupData.counter) {
                let update = await confirm("Current transaction counter value is greater than you've entered. Update this value?", "Warning")
                if (update) {
                    if (hasLeadingZero) {
                        const totalLength = parts[1].length;
                        const newStr = abSetupData.counter.toString();
                        const trimmedNew = newStr.slice(-totalLength);
                        const paddingLength = totalLength - trimmedNew.length;
                        const leading = parts[1].slice(0, paddingLength);
                        num["name"] = "Num: " + leading + trimmedNew;
                    }
                    else {
                        num["name"] = "Num: " + abSetupData.counter.toString();
                    }
                }
                
            }
            if (number > abSetupData.counter && selectedLotElementType === 'Num') 
                 setCounter(number);
        }
        return formatsDatasource;
    }
     function GetNextTransNoByExample(value) {
        if (value) {
            if (abSetupData.counter) {
                     const totalLength = value.length;
                    const newStr = abSetupData.counter.toString();
                    const trimmedNew = newStr.slice(-totalLength);
                    const paddingLength = totalLength - trimmedNew.length;
                    const leading = value.slice(0, paddingLength);
                    value =leading + trimmedNew;
            }
            else{
                    const totalLength = value.length;
                    const newStr = "0";
                    const trimmedNew = newStr.slice(-totalLength);
                    const paddingLength = totalLength - trimmedNew.length;
                    const leading = value.slice(0, paddingLength);
                    value =leading + trimmedNew;
                }
            }
        return value;
    }

    const loadSetups = async () => {
        try {
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.AB.GetAbtransnumsetup}?module=${props.field.module}&transactionType=${props.field.transactionType}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                if (res.data.generateformat) {
                    setGenerateFormat(res.data.generateformat);
                    let data = reverseStringFormat(res.data.generateformat);
                    setFormatsDatasource(data);
                }
                if (res.data.generatetransno)
                    setGenerate(res.data.generatetransno);
                setAbSetupData(res.data);
                setCounter(res.data.counter);
            } else {
                setFormatsDatasource(null);
            }
        } catch (err) {
            console.log(err, "Error while getting databases");
        }
    }
    const handleFieldChange = useCallback((name, value, e) => {

    }, []);

    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    const onSelectionChanged = (e) => {
        setSelectedRowKeys(e.selectedRowKeys);
    };

    // Remove selected row
    const removeSelectedRow = () => {
        if (selectedRowKeys.length > 0) {
            const newData = formatsDatasource.filter(row => !selectedRowKeys.includes(row.id));
            setFormatsDatasource(newData);
            setSaveFormat(!saveFormat);
        }
    };
    const deleteRecords = useCallback(() => {
        removeSelectedRow();
    });
    const addData = async () => {
        const num = formatsDatasource?.find(item => item?.name?.includes("Num: ")) ?? null;
        if (num && selectedLotElementType === 'Num') {
            alert('You can only have one incrementing number element in transaction number format.', 'Error');
            return;
        }
        let val = '';
        if (selectedLotElementType === 'D/T') {
            val = selectedFormatedText.toUpperCase();
        }
        else {
            val = selectedFormatedText;
        }
        let text = selectedLotElementType + ': ' + val;
        let format = '';
        if (formatsDatasource.length > 0 && formatsDatasource !== null && formatsDatasource !== undefined && formatsDatasource !== '') {
            const singleString = formatsDatasource.map(item => `${item.name}`).join(", ");
            format = convertStringFormat(singleString);
        }
        let totalDigits = format.length + selectedFormatedText.length;
        if (totalDigits > 36) {
            alert('Adding element would exceed maximum length of 20 characters.', 'Error');
            return;
        }

        let dataSource=formatsDatasource;
        if (selectedLotElementType === 'Num') {
           dataSource=await GetNextTransNo([...dataSource, { id: formatsDatasource.length + 1, name: text }]);
           setFormatsDatasource(dataSource);
        }
        else{
         dataSource=await GetNextTransNo(formatsDatasource);
         setFormatsDatasource([...dataSource, { id: formatsDatasource.length + 1, name: text }]);
        }
        setSaveFormat(!saveFormat);
        setFormatedText('');
        setLotElementType('User');
        setSowAddPopup(false);
    }
    function convertStringFormat(input) {
        if (input === '' || input === null || input === undefined) {
            return null;
        }
        const replacements = {
            'User': 'l',
            'D/T': 'd',
            'Num': 'i'
        };

        // Split the string into key-value pairs
        const pairs = input.split(', ');

        let result = '';

        pairs.forEach(pair => {
            const [key, value] = pair.split(': ');
            const shortKey = replacements[key] || key;

            // Add backslash and the transformed pair
            result += `\\${shortKey}${value}`;
        });

        return result;
    }
    function reverseStringFormat(input) {
        if (input === '' || input === null || input === undefined) {
            return null;
        }
        const replacements = {
            'l': 'User',
            'd': 'D/T',
            'i': 'Num'
        };

        // Split the string by backslashes and filter out empty strings
        const parts = input.split('\\').filter(part => part !== '');

        return parts.map((part, index) => {
            // Extract the type code (first character) and the value (remaining characters)
            const typeCode = part[0];
            const value = part.substring(1);

            // Get the full name from replacements or use the code if not found
            const fullName = replacements[typeCode] || typeCode;

            return {
                id: index + 1,
                name: `${fullName}: ${value}`
            };
        });
    }

    const updateFormats = () => {
        let format = null;
        if (formatsDatasource.length > 0 && formatsDatasource !== null && formatsDatasource !== undefined && formatsDatasource !== '') {
            const singleString = formatsDatasource.map(item => `${item.name}`).join(", ");
            format = convertStringFormat(singleString);
        }
        axios.put(
            `${window._env_.REACT_APP_APIS}/${data.AB.UpdateAbTransNumSetup}`,
            {
                Generateformat: format,
                Generatetransno: selectedGenerate,
                Module: props.field.module,
                Transactiontype:props.field.transactionType,
                Counter:counterNumber,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                },
            }
        )
            .then((res) => {
                setGenerateFormat(format);
                setAbSetupData(res.data);
                setCounter(res.data.counter);
                notify(
                    {
                        message: props.field.successMessage??"Record Updated Successfully",
                        width: 100,
                    },
                    'success',
                    3000,
                );
            })
            .catch((err) => {
            });
    }
    const calculateCustomSummary = (options) => {
        if (options.name == "formatSummary") {
            if (options.summaryProcess === "start") {
                options.totalValue = '';
            }
            if (options.summaryProcess === "calculate") {

                options.totalValue = getFormat();
            }
        }

    }
    function formatDate(format) {
        var date = new Date();
        // Date components
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const dayOfWeek = date.getDay();

        // Text values
        const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const fullDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const fullMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        // Padding helper
        const pad = num => num.toString().padStart(2, '0');

        // Format replacement map
        const formats = {
            // Day formats
            'D': day.toString(),
            'DD': pad(day),
            'DDD': dayNames[dayOfWeek],
            'DDDD': fullDayNames[dayOfWeek],
            'DDDDD': `${month}/${day}/${year}`,
            'DDDDDD': `${fullDayNames[dayOfWeek]}, ${fullMonthNames[month - 1]} ${day}, ${year}`,

            // Month formats
            'M': month.toString(),
            'MM': pad(month),
            'MMM': monthNames[month - 1],
            'MMMM': fullMonthNames[month - 1],

            // Year formats
            'YY': year.toString().slice(-2),
            'YYY': year.toString(),
            'YYYY': year.toString(),

            // Time formats
            'H': hours.toString(),
            'HH': pad(hours),
            //'M': minutes.toString(),
            //'MM': pad(minutes),
            'S': seconds.toString(),
            'SS': pad(seconds)
        };

        // Replace all format patterns (case-sensitive)
        return format.replace(
            /D{1,6}|M{1,4}|Y{2,4}|H{1,2}|S{1,2}/g,
            match => formats[match] || match
        );
    }
    const getFormat = () => {
        let str = '';
        let datestr = '';

        const parts = generateFormat?.split('\\').filter(part => part !== '');
        if (parts) {
            parts.map((part, index) => {

                const typeCode = part[0];
                let value = part.substring(1);

                if (typeCode === 'd') {
                    value = datestr + formatDate(value);
                }
                 if (typeCode === 'i') {
                    value = datestr + GetNextTransNoByExample(value);
                }
                str = str + value;
            });
        }

        return str;
    }
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <SelectBox
                        labelMode='static'
                        stylingMode='outlined'
                        label="Generate #"
                        displayExpr='name'
                        valueExpr='id'
                        value={selectedGenerate}
                        dataSource={[{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }]}
                        onValueChanged={handleValueChanged}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGridRef}
                        dataSource={formatsDatasource}
                        showRowLines={true}
                        showBorders={true}
                        columnAutoWidth={true}
                        disabled={selectedGenerate === 'N'}
                        remoteOperations={false}
                        keyExpr="id"
                        height={400}
                        onSelectionChanged={onSelectionChanged}

                    >
                        <Scrolling mode="standard" />
                        <Selection mode="single" />

                        <Column
                            dataField="name"
                            caption='Format'
                            allowEditing={false}
                        />
                        <Summary calculateCustomSummary={calculateCustomSummary}>
                            <TotalItem
                                name="formatSummary"
                                summaryType="custom"
                                displayFormat="Example: {0}"
                                showInColumn="name"
                            />
                        </Summary>
                        <GridToolbar>
                            <GridItem location="after">
                                <Button
                                    onClick={() => setSowAddPopup(true)}
                                    icon="plus"
                                />
                            </GridItem>
                            <GridItem location="after">
                                <Button
                                    onClick={deleteRecords}
                                    icon="trash"
                                    disabled={!selectedRowKeys.length}
                                />
                            </GridItem>
                        </GridToolbar>
                    </DataGrid>
                </div>
            </div>

            {showAddPopup && (
                <Popup
                    visible={showAddPopup}
                    onHiding={() => setSowAddPopup(false)}
                    dragEnabled={true}
                    closeOnOutsideClick={false}
                    showCloseButton={true}
                    title="Add Element"
                    width={450}
                    height={370}
                >
                    <div className="row">

                        <div className="col-md-6">
                            <RadioGroup
                                label="Element"
                                valueExpr="id"
                                displayExpr="name"
                                items={LotElementType}
                                value={selectedLotElementType}
                                onValueChanged={(e) => { setLotElementType(e.value); setFormatedText(''); setDateFormat('') }}
                                layout="vertical"
                                disabled={selectedGenerate === 'N'}
                            />
                        </div>
                        <div className="col-md-6">
                            <p style={{ marginTop: "10px" }}>
                                {selectedLotElementType === 'User' && (<>Enter any text that you want to apear for each transacton number that is generated.</>)}
                                {selectedLotElementType === 'D/T' && (<>e.g. MM/DD/YYYY or HH:NN:SS (see online help for details). Current Date w/Format :<strong>{dateFormat}</strong> </>)}
                                {selectedLotElementType === 'Num' && (<>Enter number format for an incrementing number to included in the transaction number e.g. 000145 for a six-digit number starting with 145.</>)}

                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {
                                selectedLotElementType === 'User' && (

                                    <TextBox labelMode='static'
                                        stylingMode='outlined'
                                        label="Text"
                                        maxLength={20}
                                        onValueChanged={(e) => setFormatedText(e.value)}
                                        disabled={selectedGenerate === 'N'}
                                    />
                                )}
                            {
                                selectedLotElementType === 'D/T' && (

                                    <TextBox labelMode='static'
                                        stylingMode='outlined'
                                        label="Date Time Format"
                                        maxLength={20}
                                        inputAttr={{ style: "text-transform: uppercase" }}
                                        onValueChanged={(e) => setFormatedText(e.value.toUpperCase())}
                                        onInput={(e) => {
                                            let format = formatDate(e.event.target.value.toUpperCase());
                                            setDateFormat(format)
                                        }}
                                        disabled={selectedGenerate === 'N'}
                                    />
                                )}
                            {selectedLotElementType === 'Num' && (<TextBox labelMode='static'
                                stylingMode='outlined'
                                label="Number Format"
                                maxLength={20}
                                mask="00000000000000000000"
                                onValueChanged={(e) => setFormatedText(e.value)}
                                disabled={selectedGenerate === 'N'}
                                isValid={true}
                            />
                            )
                            }

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <Button className="mt-2" text="Add" type="default" onClick={addData} disabled={selectedGenerate === 'N'} />
                        </div>
                    </div>
                </Popup>
            )}
        </>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransNumSetup);